var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgKinesis = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBF92",
    fillRule: "evenodd",
    d: "m5 22.099 14.97 6.868 14.97-6.868-14.97-.619z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    fillRule: "evenodd",
    d: "M20.017 2 5.007 9.461v10.527h17.998v-16.5z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBF92",
    fillRule: "evenodd",
    d: "M5.007 27.41 20.027 38l14.972-10.59-15.006-2.177z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    fillRule: "evenodd",
    d: "M20.017 19.988h7.918V8.755l-2.312-.922-5.606 1.63z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    fillRule: "evenodd",
    d: "M25.624 19.988h6.12v-7.286l-1.75-.523-4.371.74v7.069Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    fillRule: "evenodd",
    d: "M29.993 11.607v8.381h4.948l.058-8.418-1.503-.598z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F68534",
    d: "M20.017 2v17.988h2.988v-16.5zm7.918 6.755-2.312-.922v12.155h2.312zm3.81 3.947-1.752-.523v7.809h1.751v-7.286Zm1.751 7.286H35V11.57l-1.504-.598zm-13.525 3.603v5.376l14.97-3.719v-3.15zm0 9.1V38L35 30.511V27.41l-15.03 5.282v-.001Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D5025",
    d: "M5.007 30.544 19.971 38l-.001-5.348L5.007 27.41zM5 25.248l14.97 3.72v-5.377L5 22.099z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKinesis);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kinesis.8f9d6557.svg";